export default __webpack_public_path__ + "static/media/Google.6be85411.svg";